module.exports = __webpack_public_path__ + "img/Link.c192599c.svg";